"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.camelCase = camelCase;
exports.titleCase = titleCase;
exports.kebabCase = kebabCase;
exports.capitalCase = capitalCase;
exports.sentenceCase = sentenceCase;
exports.default = formatAddress;
const change_case_all_1 = require("change-case-all");
/**
 * Convert a string to camelCase
 * @param value
 * @returns string;
 */
function camelCase(value) {
    if (typeof value !== 'string')
        return value;
    return change_case_all_1.Case.camel(value);
}
/**
 * Convert a string to Title Case.
 * @param value
 * @returns string;
 */
function titleCase(value) {
    if (typeof value !== 'string')
        return value;
    return change_case_all_1.Case.title(value);
}
/**
 * Convert a string to kebab-case
 * @param {string} value
 * @returns {string}
 */
function kebabCase(value) {
    if (typeof value !== 'string')
        return value;
    return change_case_all_1.Case.kebab(value);
}
function capitalCase(value) {
    if (typeof value !== 'string')
        return value;
    return change_case_all_1.Case.capital(value);
}
/**
 * It capitalizes the first word of each sentence.
 * @param value
 * @returns string;
 */
function sentenceCase(value) {
    if (typeof value !== 'string')
        return value;
    change_case_all_1.Case.sentence(value);
}
/**
 * Formats a US address.
 *
 * @param {string} name - The name of the place
 * @param {string} address - The main street address.
 * @param {string | null} address2 - Additional address information (e.g., apartment number); optional.
 * @param {string} city - The city name.
 * @param {string} state - The state name or abbreviation.
 * @param {string} zipcode - The postal code.
 * @return {string} - A formatted address string.
 */
function formatAddress({ name, address, address2, city, state, zip, }) {
    let formattedAddress = '';
    if (name) {
        formattedAddress += titleCase(name);
        if (address || address2 || city || state || zip) {
            formattedAddress += ', ';
        }
    }
    if (address) {
        formattedAddress += titleCase(address);
        if (address2 || city || state || zip) {
            formattedAddress += ', ';
        }
    }
    if (address2) {
        formattedAddress += titleCase(address2);
        if (city || state || zip) {
            formattedAddress += ', ';
        }
    }
    if (city) {
        formattedAddress += titleCase(city);
        if (state || zip) {
            formattedAddress += ', ';
        }
    }
    if (state) {
        formattedAddress += state;
        if (zip) {
            formattedAddress += ' ';
        }
    }
    if (zip) {
        formattedAddress += zip;
    }
    return formattedAddress;
}
//# sourceMappingURL=textUtils.js.map